import { Card, CardContent, Typography, Box } from "@mui/material";
import { LineChart } from "@mui/x-charts";

interface ChartData {
  date: string;
  value: number;
}

export interface TrendChartProps {
  title: string;
  data: ChartData[];
  valueLabel: string;
  type?: "line" | "area";
  height?: number;
}

export function TrendChart({
  title,
  data,
  valueLabel,
  type = "line",
  height = 300,
}: TrendChartProps) {
  // Convert date strings to timestamps for x-axis
  const xAxisData = data.map((d) => new Date(d.date).getTime());
  const yAxisData = data.map((d) => d.value);

  const xAxisConfig = {
    id: "time-axis",
    scaleType: "time" as const,
    data: xAxisData,
    valueFormatter: (value: number) => {
      const date = new Date(value);
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    },
  };

  const yAxisConfig = [
    {
      valueFormatter: (value: number) => {
        if (value >= 1000) {
          return `${(value / 1000).toFixed(1)}k`;
        }
        return value.toFixed(0);
      },
    },
  ];

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>

        <Box sx={{ width: "100%", height }}>
          <LineChart
            xAxis={[xAxisConfig]}
            yAxis={yAxisConfig}
            series={[
              {
                data: yAxisData,
                label: valueLabel,
                color: "#2196f3",
                area: type === "area",
                showMark: type !== "area",
              },
            ]}
            height={height}
            margin={{ top: 10, right: 20, bottom: 40, left: 60 }}
            sx={{
              "& .MuiLineElement-root": {
                strokeWidth: 2,
              },
              "& .MuiAreaElement-root": {
                fillOpacity: 0.3,
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
